import createReactComponent from '../createReactComponent';
export default createReactComponent('coffee', 'IconCoffee', [
  [
    'path',
    {
      d: 'M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.83 -.642 2.077 -1.017 3.5 -1c1.423 -.017 2.67 .358 3.5 1',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M8 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2', key: 'svg-1' }],
  ['path', { d: 'M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2', key: 'svg-2' }],
  [
    'path',
    { d: 'M3 10h14v5a6 6 0 0 1 -6 6h-2a6 6 0 0 1 -6 -6v-5z', key: 'svg-3' },
  ],
  ['path', { d: 'M16.746 16.726a3 3 0 1 0 .252 -5.555', key: 'svg-4' }],
]);
